import React, { useState, useEffect } from "react";
import Modal from "../components/Modal";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import {
    faTimes
  } from "@fortawesome/free-solid-svg-icons";


  const defaultAzureOpenAIConfig = {  
    AZURE_BASE_URL: "",
    AZURE_INDEX_NAME: "",
    AZURE_MAX_TOKENS: null,
    AZURE_MODEL: "",
    AZURE_OPENAI_KEY: "",
    AZURE_SEARCH_ENDPOINT: "",
    AZURE_SEARCH_KEY: "",
  };


const AzureOpenAIModal = ({ azureOpenAIConfig = defaultAzureOpenAIConfig, systemMessage, onClose, onSave }) => {
  
  
  const [config, setConfig] = useState(defaultAzureOpenAIConfig );
  const [localSystemMessage, setLocalSystemMessage] = useState(systemMessage);

  useEffect(() => {
    setLocalSystemMessage(systemMessage);
  }, [systemMessage]);
  

    useEffect(() => {
        setConfig(() => ({
          ...azureOpenAIConfig,

        }));
      }, [azureOpenAIConfig]);
  
 
      const handleSystemMessageChange = (e) => {
        setLocalSystemMessage(e.target.value);
    };
    
    const handleChange = (e) => {
        const { name, value } = e.target;
        setConfig((prevConfig) => ({
            ...prevConfig,
            [name]: value,
        }));
    };
    
    
    
 
  const handleSave = () => {
    onSave(config, localSystemMessage, );
  };
 
  return (
    <Modal onClose={onClose} width={600} height={400}>
      <div className="azure-openai-modal">
        <div className="azure-openai-modal-header">
            <p>Azure OpenAI Configuration</p>
        </div>
        <div className="close-icon" onClick={onClose}>
                <FontAwesomeIcon icon={faTimes} />
              </div>
        
        <form>
          <div className="form-group">
            <label htmlFor="AZURE_BASE_URL">Azure Base URL</label>
            <input
              type="text"
              id="AZURE_BASE_URL"
              name="AZURE_BASE_URL"
              value={config.AZURE_BASE_URL}
              onChange={handleChange}
              placeholder="Enter Azure Base URL"
            />
          </div>
          <div className="form-group">
            <label htmlFor="AZURE_INDEX_NAME">Azure Index Name</label>
            <input
              type="text"
              id="AZURE_INDEX_NAME"
              name="AZURE_INDEX_NAME"
              value={config.AZURE_INDEX_NAME}
              onChange={handleChange}
              placeholder="Enter Azure Index Name"
            />
          </div>
          <div className="form-group">
            <label htmlFor="AZURE_MAX_TOKENS">Azure Max Tokens</label>
            <input
              type="number"
              id="AZURE_MAX_TOKENS"
              name="AZURE_MAX_TOKENS"
              value={config.AZURE_MAX_TOKENS || ""}
              onChange={handleChange}
              placeholder="Enter Azure Max Tokens"
            />
          </div>
          <div className="form-group">
            <label htmlFor="AZURE_MODEL">Azure Model</label>
            <input
              type="text"
              id="AZURE_MODEL"
              name="AZURE_MODEL"
              value={config.AZURE_MODEL}
              onChange={handleChange}
              placeholder="Enter Azure Model"
            />
          </div>
          <div className="form-group">
            <label htmlFor="AZURE_OPENAI_KEY">Azure OpenAI Key</label>
            <input
              type="text"
              id="AZURE_OPENAI_KEY"
              name="AZURE_OPENAI_KEY"
              value={config.AZURE_OPENAI_KEY}
              onChange={handleChange}
              placeholder="Enter Azure OpenAI Key"
            />
          </div>
          <div className="form-group">
            <label htmlFor="AZURE_SEARCH_ENDPOINT">Azure Search Endpoint</label>
            <input
              type="text"
              id="AZURE_SEARCH_ENDPOINT"
              name="AZURE_SEARCH_ENDPOINT"
              value={config.AZURE_SEARCH_ENDPOINT}
              onChange={handleChange}
              placeholder="Enter Azure Search Endpoint"
            />
          </div>
          <div className="form-group">
            <label htmlFor="AZURE_SEARCH_KEY">Azure Search Key</label>
            <input
              type="text"
              id="AZURE_SEARCH_KEY"
              name="AZURE_SEARCH_KEY"
              value={config.AZURE_SEARCH_KEY}
              onChange={handleChange}
              placeholder="Enter Azure Search Key"
            />
          </div>
          <div className="form-group">
            <label htmlFor="systemMessage">Azure Prompt Message</label>
            <textarea
                id="systemMessage"
                name="systemMessage"
                rows="4"
                cols="50"
                type="text"
                value={localSystemMessage.systemMessage}
                onChange={handleSystemMessageChange}
                placeholder="Enter Azure Prompt Message"
            />
          </div>
        </form>
        <div className="modal-actions">
          <button className="submit-btn" onClick={handleSave}>Save</button>
        </div>
      </div>
    </Modal>
  );
};
 
export default AzureOpenAIModal;